// extracted by mini-css-extract-plugin
export var bgImg = "where-to-buy-bar-module--bgImg--a5Dpm";
export var buttonHolder = "where-to-buy-bar-module--buttonHolder--1ZgPD";
export var descriptionHolder = "where-to-buy-bar-module--descriptionHolder--J6TJP";
export var midContainer = "where-to-buy-bar-module--midContainer--kcbE4";
export var outerContainer = "where-to-buy-bar-module--outerContainer--i7tg4";